import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const BarChartComponent = ({ data }) => {
  const chartData = {
    labels: data.labels,
    datasets: [
      {
        label: "No of transactions",
        data: data.values,
        backgroundColor: '#003366',
        borderColor: '#003366',
        borderWidth: 1,
        barThickness: 20,
      },
    ],
  };

  const options = {
    responsive: true,
    indexAxis: 'x',
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: !!data.title, // Only show title if provided
        text: data.title || '', // Dynamic title text
        font: {
          size: 20,
          weight: 'bold',
          family: 'Arial',
        },
        color: '#333',
        padding: { top: 20, bottom: 10 },
        align: 'center',
      },
      tooltip: {
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        titleColor: '#FFF',
        bodyColor: '#FFF',
        borderColor: '#FFF',
        borderWidth: 1,
        padding: 10,
        callbacks: {
          label: (tooltipItem) => `${tooltipItem.dataset.label}: ${tooltipItem.raw}`,
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };

return (
  <div className="BarChartComponent">
    <Bar data={chartData} options={options} />
  </div>
);
};

export default BarChartComponent;
